var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "multipe-select-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.title) + _vm._s(_vm.activeNum && !_vm.ifR ? `(${_vm.activeNum})` : "") + " ")]), _c('el-select', {
    attrs: {
      "disabled": _vm.ifR,
      "multiple": "",
      "popper-class": "multipe-select-menu",
      "placeholder": "",
      "popper-append-to-body": _vm.appendToBody
    },
    on: {
      "change": _vm.change,
      "visible-change": _vm.visibleChange
    },
    model: {
      value: _vm.checkList,
      callback: function ($$v) {
        _vm.checkList = $$v;
      },
      expression: "checkList"
    }
  }, _vm._l(_vm.dataList, function (item, index) {
    return _c('el-option', {
      key: item[_vm.keyArray[0]],
      class: item.color,
      attrs: {
        "label": _vm.useDefault ? _vm.$t(`lang.${item.label}`) : item[_vm.keyArray[1]],
        "value": item[_vm.keyArray[0]]
      }
    }, [_vm.hasOnGoing && index == _vm.dataList.length - 1 ? _c('hr', {
      staticClass: "seperateLine"
    }) : _vm._e(), !_vm.noCheckBox ? _c('el-checkbox', {
      model: {
        value: item[_vm.keyArray[2]],
        callback: function ($$v) {
          _vm.$set(item, _vm.keyArray[2], $$v);
        },
        expression: "item[keyArray[2]]"
      }
    }) : _vm._e(), _vm._t("deviceIcon", null, {
      "iconVal": item.icon
    }), _c('div', {
      staticClass: "name",
      class: _vm.judgeClass(item)
    }, [_vm._v(_vm._s(_vm.useDefault ? _vm.$t(`lang.${item.label}`) : item[_vm.keyArray[1]]))])], 2);
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }